import React, {
	Component
} from 'react';
import Global from '../../Global';

import './eCareServiceDetail.css';

class eCareServiceDetail extends Component {

	constructor(props) {
		super(props);

		this.state = {

		}
	}

    render(){		
        return (
            <div id="eCareServiceDetail">
				<div className="row">
                    <div className="col-xs-12">
                        <img src={this.props.boxImage} border='0' />
                        <div className="detail-title">{this.props.boxTitle}</div>
                    </div>
                    <div className="col-xs-12">
                        <div className="detail-content">
                            {this.props.boxDesc}
                            {/*<a href={this.props.boxUrl} >*/}
                            {this.props.boxDesc2}
                            {/*</a>*/}
                            {this.props.boxDesc3}
                            <br />
                            {this.props.boxDesc4}
                        </div>
                    </div>
                </div>
			</div>
        );
    }
}

export default eCareServiceDetail;